import React from 'react'
import { connect as connectRedux } from 'react-redux'
import compose from 'recompose/compose'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'
import { Map, List } from 'immutable'
import { connect as connectStaticText } from '../../StaticText/connect'
import { getBoundActions } from '../../../actions/index'
import ButtonToggle from '../../ButtonToggle/index'
import { AI_MODULE_VISIBILITY_TOGGLED_GA4_EVENT } from '../../../services/event-tracking/index'
import { PM_SCREEN_TYPE_MEMBER_HOME } from '../../../services/pm-screen/types'
import { getPrimary } from '../../../services/languages/index'
import { usePostHogEvent } from '../../PostHog/index'

const AIVisibilitySettings = (props) => {
  const {
    mhAiHidden,
    staticText,
    setFeatureTrackingDataPersistent,
    mhPmScreenSectionIds = List(),
    deletePmScreen,
    deleteMultiplePMSections,
    userLanguage,
  } = props

  const trackVideoguideEnabled = usePostHogEvent('aiVideoguideEnabled')
  const trackVideoguideDisabled = usePostHogEvent('aiVideoguideDisabled')

  const onAIVisibilitySettingsChange = () => {
    // Track PostHog event based on the new state
    if (mhAiHidden) {
      // Currently hidden, toggling to show → enabled
      trackVideoguideEnabled()
    } else {
      // Currently visible, toggling to hide → disabled
      trackVideoguideDisabled()
    }

    setFeatureTrackingDataPersistent({
      data: Map({ mhAiHidden: !mhAiHidden }),
    })

    // reset MH PM screen if it exists
    if (mhPmScreenSectionIds.size > 0) {
      deletePmScreen(PM_SCREEN_TYPE_MEMBER_HOME, userLanguage)
      deleteMultiplePMSections(mhPmScreenSectionIds)
    }
  }

  // GA4 events
  const toggleEventData = AI_MODULE_VISIBILITY_TOGGLED_GA4_EVENT.mergeDeep({
    changed_to: mhAiHidden ? 'on' : 'off',
    ui_location: 'Settings',
  })

  return (
    <div className="my-account-settings-V2__display-settings-controls">
      <div className="my-account-settings-V2__display-settings-text-container">
        <div className="my-account-settings-V2__display-settings-title">
          { staticText.getIn(['data', 'homepageSages']) }
        </div>
        <div className="my-account-settings-V2__display-settings-text">
          {staticText.getIn(['data', 'homepageSagesDesc'])}
        </div>
      </div>
      <div className="my-account-settings-V2__display-settings-toggle">
        <ButtonToggle
          checked={!mhAiHidden}
          onChange={onAIVisibilitySettingsChange}
          showLabel
          ga4EventData={toggleEventData}
          round
        />
      </div>
    </div>
  )
}

AIVisibilitySettings.propTypes = {
  mhAiHidden: PropTypes.bool,
  setFeatureTrackingDataPersistent: PropTypes.func.isRequired,
  mhPmScreen: ImmutablePropTypes.map.isRequired,
  deletePmScreen: PropTypes.func.isRequired,
  deleteMultiplePMSections: PropTypes.func.isRequired,
  userLanguage: PropTypes.string.isRequired,
}

export default compose(
  connectRedux(
    (state) => {
      const { user } = state
      const userLanguage = getPrimary(user.getIn(['data', 'language']))
      const mhPmScreenSectionIds = state.pmScreen.getIn([PM_SCREEN_TYPE_MEMBER_HOME, userLanguage, 'data', 'sectionIds'], List()) || List()

      return {
        mhAiHidden: state.featureTracking.getIn(['data', 'mhAiHidden'], false),
        mhPmScreenSectionIds,
        userLanguage,
      }
    },
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        setFeatureTrackingDataPersistent: actions.featureTracking.setFeatureTrackingDataPersistent,
        deletePmScreen: actions.pmScreen.deletePmScreen,
        deleteMultiplePMSections: actions.pmSection.deleteMultiplePMSections,
      }
    },
  ),
  connectStaticText({ storeKey: 'myAccountSettingsV2' }),
)(AIVisibilitySettings)
